import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TrnAdmissionService {
    trnAdmission: any;
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'trn_admission/list/?';
    private AddRecord = webapi + 'trn_admission/create';
    private EditRecord = webapi + 'trn_admission/update';
    private GetRecord = webapi + 'trn_admission/byid/';
    private GetRecordbypatientid = webapi + 'trn_admission/bypatientid/';
    private AdmissionListRecord = webapi + 'trn_admission/admissionlist/?';
    private DischargeListRecord = webapi + 'trn_admission/Dischargelist/?';
    private ListAdmissionSearchMRRecord = webapi + 'trn_admission/listadmissionsearchbymr/?';
    private ListAdmissionSearchNonDischargePatient = webapi + 'trn_admission/listadmissionsearchbyMrNoNonDischarge/?';
    private ListAdmissionSearcNamehRecord = webapi + 'trn_admission/listadmissionsearchbyname/?';
    private ListAdmissionSearchMobilRecord = webapi + 'trn_admission/listadmissionsearchbymobile/?';
    private ListAdmissionSearchPhoneRecord = webapi + 'trn_admission/listadmissionsearchbyphone/?';
    private ListAdmissionSearchIdRecord = webapi + 'trn_admission/listadmissionsearchbyid/?';
    private ListAdmissionSearchMailRecord = webapi + 'trn_admission/listadmissionsearchbymail/?';
    private DeleteRecord = webapi + 'trn_admission/delete/';
    private SearchRecord = webapi + 'trn_admission/searchadmission/?';
    private GetRecordLast = webapi + 'trn_admission/searchlastadmission/?';
    private GetAutocomplitemrno = webapi + 'trn_admission/autocomplete/';
    private GetBetUnderNursingStation = webapi + 'trn_admission/onlyadmittedlist/';
    private Getallocatedbed = webapi + 'trn_admission/allocatedbed/';
    private Allperformby = webapi + 'trn_admission/performbylist/';
    private patientbedrealease = webapi + 'trn_admission/patientbedrealease/';
    private GetAutocomplitemrnounit = webapi + 'trn_admission/patientsearchipd/';
    private GetAdmissionListByPatientId = webapi + 'trn_admission/getAdmissionListByPatientId/';
    private setexpecteddate = webapi + 'trn_admission/expecteddischargedate/';
    private finalizedDischargeURL = webapi + 'trn_admission/dischage_patient/';

    private Dailybedstatus = webapi + 'daily_occupancy/getdailyoccupancy/';
    private Dailybedstatusexcel = webapi + 'daily_occupancy/getdailyoccupancyexcel/true/';

    private Bedupdate = webapi + 'trn_admission/patientbedtransfer/';
    private MultiBedupdate = webapi + 'trn_admission/patientmultibed/?';
    private admissioncancle = webapi + 'trn_admission/admissioncanclebyid/';
    private Dischargecancel = webapi + 'trn_admission/dischargecancel/';
    private getDischargeBydate = webapi + 'trn_admission/getDischargeListByDate/?';
    private getAdmissionBydate = webapi + 'trn_admission/getAdmissionListByDate/?';
    private cancleAdmissionById = webapi + 'trn_admission/cancleadmissionbyid/?';
    private CancelledListRecord = webapi + 'trn_admission/cancelledlist/?';
    private GetPharIPDOutstanding = webapi + 'trn_admission/getPharIPDOutstanding/';
    private CheckIsAlreadyAdmitted = webapi + 'trn_admission/checkIsAlreadyAdmitted/';
    private wardwisebedsummay = webapi + 'trn_admission/getwardwisebedsummay/';
    private openBill = webapi + 'trn_admission/openBillByAdmissionId/';
    private closeBill = webapi + 'trn_admission/closeBillByAdmissionId/';
    private getCompanyName =  webapi + 'mst_patient/getCompanyNameByPatientId/';
    private getCompanyNameByVisit =  webapi + 'mst_patient/getCompanyNameByVisitId/';

    constructor(private http: Http) {
    }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllAdmissionRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        // console.log(this.AdmissionListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col);
        return this.http.get(this.AdmissionListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllAdmissionRecordServicefilter(currentPage: any, size: any, qString: any, sort: any, col: any, type: any, model: any, unitId: any): Promise<any> {
        return this.http.post(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&type=' + type + '&unitId=' + unitId, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllAdmissionCancelRecordServicefilter(currentPage: any, size: any, qString: any, sort: any, col: any, type: any, unitId: any): Promise<any> {
        return this.http.get(this.CancelledListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&type=' + type + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllDischargeRecordService(currentPage: any, size: any, qString: any, sort: any, col: any, type: any): Promise<any> {
        return this.http.get(this.DischargeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&type=' + type + '&unitId=' + sessionStorage.getItem('unitId'))
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getallocatedbedlist(): Promise<any> {
        return this.http.get(this.Getallocatedbed)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getmrnounitwiseautocomplite(mrno: any, unitId: any): Promise<any> {
        return this.http.get(this.GetAutocomplitemrnounit + mrno + '/' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getmrnoautocomplite(mrno: any): Promise<any> {
        return this.http.get(this.GetAutocomplitemrno + mrno)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getLastRecordForAutoAll(qString: string) {
        return this.http.get(this.GetRecordLast + 'qString=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    searchRecordService(qString: any) {
        return this.http.get(this.SearchRecord + 'qString=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any) {
        return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordServicepatientid(id: any) {
        return this.http.get(this.GetRecordbypatientid + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getbedrealeaseService(id: any) {
        // console.log(this.patientbedrealease + id);
        return this.http.get(this.patientbedrealease + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getBedUnderNst(nstId: any): Promise<any> {
        return this.http.get(this.GetBetUnderNursingStation + nstId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getperformAll(admissionid: any): Promise<any> {
        return this.http.get(this.Allperformby + admissionid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAdmissionSearchMr(qString: any) {
        return this.http.get(this.ListAdmissionSearchMRRecord + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAdmissionSearchMrNoNonDischargePatient(qString: any) {
        return this.http.get(this.ListAdmissionSearchNonDischargePatient + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAdmissionSearchName(qString: any) {
        return this.http.get(this.ListAdmissionSearcNamehRecord + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAdmissionSearchMoile(qString: any) {
        return this.http.get(this.ListAdmissionSearchMobilRecord + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAdmissionSearchPhone(qString: any) {
        return this.http.get(this.ListAdmissionSearchPhoneRecord + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAdmissionSearchId(qString: any) {
        return this.http.get(this.ListAdmissionSearchIdRecord + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAdmissionSearchMail(qString: any) {
        return this.http.get(this.ListAdmissionSearchMailRecord + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    setexpecteddischargedate(admissionid: any, dischargedate: any): Promise<any> {
        return this.http.get(this.setexpecteddate + admissionid + '/' + dischargedate)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAdmissionListByPatientId(patientId: any) {
        return this.http.get(this.GetAdmissionListByPatientId + patientId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getFinalizedDischarge(admissionId: any): Promise<any> {
        return this.http.get(this.finalizedDischargeURL + admissionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getdailybedstatusrecord(user): Promise<any> {
        return this.http.get(this.Dailybedstatus + user)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);


    }
    getdailybedstatusrecordByUser(user:any): Promise<any>  {
        return this.http.get(this.Dailybedstatus + user)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }




    getdailybedstatusrecordexcel(user): Promise<any> {
        return this.http.get(this.Dailybedstatusexcel + user)
            .toPromise()
            .then(fileName => fileName.text())
            .catch(this.handleError);
    }

    bedupdate(admissionId: any, bedId: any, bedlist: any) {
        return this.http.get(this.Bedupdate + admissionId + '/' + bedId + '/' + bedlist)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    multibedupdate(admissionId: any, bedlist: any) {
        // console.log(this.MultiBedupdate + 'admissionId=' + admissionId + '&bedlist=' + bedlist);
        return this.http.post(this.MultiBedupdate + 'admissionId=' + admissionId, JSON.stringify(bedlist), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    admissioncancleService(id: any) {
        return this.http.get(this.admissioncancle + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    cancleAdmissionService(admissionId: any, admissionCancelReason: any) {
        return this.http.get(this.cancleAdmissionById + 'admissionId=' + admissionId + '&admissionCancelReason=' + admissionCancelReason)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    dischargeCancelService(dischargeid: any, admissionid: any, bedid: any, user: any) {
        return this.http.get(this.Dischargecancel + dischargeid + '/' + admissionid + '/' + bedid + '/' + user)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllDischargeRecordServicefilter(today: any, startdate: any, endate: any, unitId: any, currentPage: any, size: any): Promise<any> {
        return this.http.get(this.getDischargeBydate + 'today=' + today + '&startdate=' + startdate + '&endate=' + endate + '&unitId=' + unitId + '&page=' + currentPage + '&size=' + size)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }

    getAllAdmissionRecordServicefilterr(currentPage: any, size: any, qString: any, sort: any, col: any, type: any): Promise<any> {
        return this.http.get(this.getAdmissionBydate + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&type=' + type)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPharIPDOutstanding(admissionId: any): Promise<boolean> {
        return this.http.get(this.GetPharIPDOutstanding + admissionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    openIpdBillService(admissionId: any): Promise<boolean> {
        return this.http.get(this.openBill + admissionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    closeIpdBillService(admissionId: any): Promise<boolean> {
        return this.http.get(this.closeBill + admissionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    checkIsAlreadyAdmitted(patientId: any) {
        return this.http.get(this.CheckIsAlreadyAdmitted + patientId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    wardWiseBedSummaryService() {
        return this.http.get(this.wardwisebedsummay)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getCompanyNameByPatientId(patientId: number){
        return this.http.get(this.getCompanyName + "/" + patientId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getCompanyNameByVisitId(visitId: number){
        return this.http.get(this.getCompanyNameByVisit + "/" + visitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/trn-admission/trn-admission.service.ts